
import O1HD, { modules } from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { PLATFORM_CODE } from "../../../../engines/services/ossService";
import { FileKind } from "../../../define/FileKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { UIKind } from "../../../define/UIKind";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import { getOilfieldConfig, getOilfieldConfigH5 } from "./config/oilfieldConfig";
import { OilFieldCollect, oilfieldDataHelp } from "./config/oilfieldDataHelp";
import oilfieldMinePage from "./oilfieldMinePage";

const { ccclass, property } = cc._decorator;

@ccclass
export default class oilfieldChoosePage extends cc.Component {

    @property(cc.Node)
    nodeBlackShadow: cc.Node = null;
    @property({ type: cc.Node, displayName: "油田列表" })
    oilfieldGroup: cc.Node = null;
    @property({ type: cc.Node, displayName: "换一批按钮节点" })
    node_huanBtn: cc.Node = null;

    @property(cc.Node)
    nodeCollect: cc.Node = null;
    @property(cc.Node)
    nodeCollect2: cc.Node = null;
    @property(cc.Node)
    nodeKongTong: cc.Node = null;
    @property(cc.Node)
    btnCollect: cc.Node = null;

    start() {
        oilfieldDataHelp.init(NormalGameManager._instance.getGameData().oilfieldData)
        this.refresh();

        O1HD.on(MessageEventKind.EventName.GAME_OILFIELD_DATA, this.refresh, this)
        utilsView.enterLayerDispose(UIKind.UILayerTag.OilFieldLayer, this.node);
        O1HD.on(MessageEventKind.EventName.REFRESH_OilField_COLLECT_STATE, this.refreshCollectState, this);
        O1HD.on(MessageEventKind.EventName.REFRESH_OilField_COLLECT_Finish, this.showCollectFinish, this);

        this.refreshCollectState();
        this.refreshBlackShadow();
        
    }

    refresh() {
        let OilFieldConifg = getOilfieldConfig;
        if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
            OilFieldConifg = getOilfieldConfigH5;
        }
        let oilfieldList = oilfieldDataHelp.getData().mineInfo;
        // this.node_huanBtn.active = false;
        for (let i = 0, len = this.oilfieldGroup.childrenCount; i < len; i++) {
            let data = oilfieldList[i];
            let node = this.oilfieldGroup.children[i];

            node.active = !data.ismine;
            // if (!this.node_huanBtn.active)
            //     this.node_huanBtn.active = data.ismine;
            if (node.active) {
                let labname = node.getChildByName("labName").getComponent(cc.Label);
                let labPrice = node.getChildByName("labPrice").getComponent(cc.Label);

                labname.string = OilFieldConifg[data.id].name;
                labPrice.string = `${data_control.getNumberFormat(OilFieldConifg[data.id].buyPrice, 0)}`
            }

            node.targetOff(this);
            node.on(cc.Node.EventType.TOUCH_END, () => {
                this.onClickToggle(data.id)
            }, this)
        }
    }

    showCollectFinish() {
        this.nodeCollect2.active = true;
        this.nodeKongTong.active = true;
        this.btnCollect.active = false;
        this.nodeKongTong.opacity = 0;

        
        cc.tween(this.nodeCollect2)
        .to(0.25, {opacity: 0})
        .start();

        cc.tween(this.nodeKongTong)
        .to(0.25, {opacity: 255})
        .call(this.refreshCollectState.bind(this))
        .start();

    }

    refreshCollectState() {
        let gameData = NormalGameManager._instance.getGameData();

        this.nodeCollect2.active = !gameData.bShowKongTongBtn;
        this.btnCollect.active = !gameData.bShowKongTongBtn;
        this.nodeKongTong.active = gameData.bShowKongTongBtn;
        if (gameData.bShowKongTongBtn) {
            return;
        }

        let colletConfig = OilFieldCollect;
        this.nodeCollect.children.forEach((v, i)=> {
            let item = colletConfig[i];
            let goods = NormalGameManager._instance.getOneGood(item);
            v.active = true;
            if (!goods || goods.num <= 0)  {
                v.active = false;
            }
        });
    }

    onClickCollect() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        
        O1HD.getModules().uiControlModule.showLoading();
        utilsView.openPopupLayer(
            'prefab/OpenOilFieldCollectLayer'
            , BUNDLE_SMALL_NAME.oilfield
            , null
            , null
            , null
            , null
            , false
        );
    }

    /**
     * 崆峒镜
     */
    onClickKongTongLayer() { 
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.ThruTimeAccessLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.ThruTimeAccessLayer
            , null
            , null
            , UI_Z_INDEX.DIALOG
            , null
            , false
        );
    }

    async onClickToggle(id: number) {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        let oilfieldList = oilfieldDataHelp.getData().mineInfo;
        if (oilfieldList[id].ismine) return modules().uiControlModule.showMessageBox("已经开采过了");

        let OilFieldConifg = getOilfieldConfig;
        if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
            OilFieldConifg = getOilfieldConfigH5;
        }

        let oilfieldid = oilfieldList[id].id;
        let info = OilFieldConifg[oilfieldid];
        if (O1HD.getServices().userSrv.getCoins() <= info.buyPrice) {
            return modules().uiControlModule.showMessageBox("金额不足，无法购买");
        }

        // 开采了
        // this.node_huanBtn.active = true;
        O1HD.getServices().userSrv.setCoins(-info.buyPrice, true);
        oilfieldDataHelp.addMineTimes()
        oilfieldDataHelp.setOilfield(info.id)
        
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.oilfield, "prefab/oilfieldMinePage");
        let node:cc.Node = cc.instantiate(prefab);
        node.setParent(O1HD.Canvas()); 
        node.getComponent(oilfieldMinePage).init(info.id)


        // // 弹窗显示
        // let page: PageBase;
        // let prams: OilFieldBuyPrams = {
        //     id: info.id,
        //     callBack: async () => {
        //         // 开采了
        //         this.node_huanBtn.active = true;
        //         O1HD.getServices().userSrv.setCoins(-info.buyPrice, true);
        //         oilfieldDataHelp.addMineTimes()
        //         oilfieldDataHelp.setOilfield(info.id)
        //         O1HD.getManagers().soundMgr.playSound('anNiu');
        //         this.scheduleOnce(async () => {

        //             let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.oilfield, "prefab/oilfieldMinePage");
        //             let node:cc.Node = cc.instantiate(prefab);
        //             node.setParent(O1HD.Canvas()); 
        //             node.getComponent(oilfieldMinePage).init(info.id)
        //         }, 0.5)
        //     }
        // }
        // page = await modules().uiControlModule.OpenPage("prefab/oilfieldBuyPage", UI_Z_INDEX.DIALOG, prams, getOneBundleByInstant(BUNDLE_SMALL_NAME.oilfield), true);

    }
    onClickBack() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        this.node && this.node.isValid && this.node.destroy();
    }
    clickTime: number = null;

    onClickChange() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        if (this.clickTime != null && new Date().getTime() - this.clickTime < 3000) return;
        this.clickTime = new Date().getTime()
        cc.game.pause();

        
        utilsModel.loadAndShowVideoAdTrans(async () => {
            cc.game.resume();
            oilfieldDataHelp.newDayRefresh()
        }, () => {
            cc.game.resume();
        }, null, '刷新油田')
    }

    refreshBlackShadow() {
        let gameData = NormalGameManager._instance.getGameData();
        this.nodeBlackShadow.active = !gameData.bTouchOilFieldBlack;
    }

    onClickBlack() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        NormalGameManager._instance.setGameData({bTouchOilFieldBlack: true});
        NormalGameManager._instance.addOneWeChatTriggerLink('54');
        this.refreshBlackShadow();
    }
}